import { CampaignAPI } from "generated-api"

export enum CAP_PERIODS {
  MONTH = "month",
  WEEK = "week",
  DAY = "day",
  HOUR = "hour",
  // QUARTER = "quarter",
  MINUTE = "minute"
  // SECOND = "second",
  // CAMPAIGN = "campaign"
}
const ALL_CAP_PERIODS: CAP_PERIODS[] = [
  CAP_PERIODS.MONTH,
  CAP_PERIODS.WEEK,
  CAP_PERIODS.DAY,
  CAP_PERIODS.HOUR,
  // CAP_PERIODS.QUARTER,
  CAP_PERIODS.MINUTE
  // CAP_PERIODS.SECOND,
  // CAP_PERIODS.CAMPAIGN
]
export const getAllCapsPeriod = (): CAP_PERIODS[] => ALL_CAP_PERIODS.slice()

export type ICapDTO = Awaited<ReturnType<typeof CampaignAPI.getApiCampaignCapList>>[0]
export type ICap = Omit<ICapDTO, "period"> & { period: CAP_PERIODS }

/* X display during Y Z
export interface ICap {
  id: number
  frequency: number // Y - always be equals to 1
  units: number // X - this is the "real" frequency
  period: CAP_PERIODS // Z
}*/

export interface ICapRepository {
  getCaps(campaignId: number): Promise<ICap[]>
  createCap(campaignId: number, cap: ICap): Promise<ICap>
  updateCap(campaignId: number, cap: ICap): Promise<ICap>
  deleteCap(campaignId: number, capId: number): Promise<void>
}
